import React from 'react';
import AnnualReport from '../../../containers/AnnualReport';

const NodeAnnualReport = ({ entity, className }) => {
  return (
    <AnnualReport
      entity={entity}
    />
  );
};

export default NodeAnnualReport;
